import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { ConfirmInterviewContainer } = await import('./index');
    return {
        Component: ConfirmInterviewContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
